import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Heading: FC = () => {
    const { t } = useTranslation()

    return (
        <Typography.Heading variant="h5" style={{ color: ColorEnum.GRAY_900 }}>
            {t('common.overview.header')}
        </Typography.Heading>
    )
}

export default Heading
